import {
  Component,
  ViewChild,
  TemplateRef,
  AfterViewInit,
  OnInit,
  OnDestroy,
  ElementRef,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { RouterOutlet } from '@angular/router';
import { HelperFunctionsService } from './services/helper-functions.service';
import { siRouterFadeAnimation } from '@simpl/siemens-brand-ng/tools';
import { returnDeactivate, returnText } from '../state/selectors';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  animations: [siRouterFadeAnimation],
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('toastTemplate', { static: true })
  toastTemplate!: TemplateRef<any>;

  myItDigitalAssistant = environment['NG_APP_MYIT_DIGITAL_ASSISTANT'];
  reportAnIncident = environment['NG_APP_REPORT_AN_INCIDENT'];

  greyOut: string = '';
  private subscriptions: Subscription[] = [];

  constructor(
    private store: Store,
    private helperService: HelperFunctionsService,
    private _elementRef: ElementRef
  ) {}

  ngOnInit(): void {
    // hide angular version // Security best practices recommend only exposing information necessary for the correct operation of an application
    this._elementRef.nativeElement.removeAttribute("ng-version");
    // Subscribe to deactivate state for grey-out effect
    this.subscriptions.push(
      this.store.select(returnDeactivate).subscribe((deactivate) => {
        this.greyOut = deactivate ? 'pointer-events: none; opacity: 0.4;' : '';
      })
    );

    // Register toast template with helper service
    this.helperService.setToastTemplate(this.toastTemplate);
  }

  /**
   * fetches a language specific message from the store
   * @param id
   * @returns msg
   */
  textFetch(id: string): string {
    let msg = '';
    this.store
      .select(returnText(id))
      .subscribe((val) => {
        msg = val;
      })
      .unsubscribe();
    return msg;
  }

  ngAfterViewInit(): void {
    if (this.toastTemplate) {
      this.helperService.setToastTemplate(this.toastTemplate);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  getRouteAnimation(outlet: RouterOutlet): string {
    return outlet?.activatedRouteData?.['animation'];
  }
}
